var map = {
	"./1.png": "c1c5",
	"./2.png": "81e5",
	"./3.png": "619a",
	"./4.png": "33b2",
	"./5.png": "4660",
	"./500.webp": "3d4c",
	"./6.png": "97ca",
	"./7.png": "8efd",
	"./8.png": "570d",
	"./Asset 2.png": "52c1",
	"./Asset1.png": "3628",
	"./Asset2.png": "7613",
	"./Asset5.png": "24c6",
	"./BLNK.jpg": "0e06",
	"./Bil.png": "8014",
	"./Component 4 – 90.svg": "d2e9",
	"./Component3.png": "db10",
	"./Ellipse 23@2x.png": "4ae4",
	"./Ellipse23.png": "8863",
	"./Group 478.svg": "e741",
	"./Group208.svg": "a9ca",
	"./Mask Group 1.svg": "6518",
	"./Path 753-3.svg": "ac2c",
	"./acc.webp": "acf8",
	"./add.png": "fbc1",
	"./add.svg": "24e9",
	"./analytic.png": "58d3",
	"./analytics.svg": "2f00",
	"./arrow.svg": "27e4",
	"./backgr.jpg": "f939",
	"./cake black 24dp.png": "fe33",
	"./class.svg": "bfa2",
	"./close.png": "d991",
	"./clsndtchr.png": "00a0",
	"./delete.svg": "2c46",
	"./email black 24dp.png": "5657",
	"./emoji events black 24dp.svg": "21e2",
	"./error.png": "fa93",
	"./exam.svg": "7cdc",
	"./exmlogo.svg": "617d",
	"./food.png": "1419",
	"./food1.jpg": "639f",
	"./food2.jpg": "9db1",
	"./food3.jpg": "23be",
	"./food4.webp": "0539",
	"./food5.jpg": "366c",
	"./food6.jpg": "3399",
	"./food7.jpg": "7a2e",
	"./food8.jpg": "1320",
	"./grocery.png": "33d8",
	"./home black 24dp.png": "2b31",
	"./icon2.png": "9aa4",
	"./img2.jpg": "692a",
	"./login-main.svg": "863f",
	"./logo.png": "9d64",
	"./logo1.png": "b189",
	"./male black 24dp.png": "d985",
	"./notice.svg": "21c2",
	"./noticeboard.png": "686c",
	"./nouser.png": "a6c7",
	"./phone iphone black 24dp.png": "7a97",
	"./purchase.png": "3173",
	"./purchasehistory.png": "5982",
	"./purple.jpg": "35e1",
	"./report.png": "0a82",
	"./school.svg": "77eb",
	"./staff.png": "e1e5",
	"./student.png": "70ce",
	"./subject.svg": "3d1c",
	"./subjectlogo.svg": "08d5",
	"./success.png": "46e6",
	"./supplier.png": "70ef",
	"./teacher.svg": "8132",
	"./tick.svg": "f273"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";